export const API_BASE_URL = "https://cms.cms-gabon.com/api";